// opervex-frontend/src/Opervex/Accounting/Customers.js

class Customers {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findAll() {
    return this.#_api.get("/Accounting/Customers");
  }

  async findId(id) {
    return this.#_api.get(`/Accounting/Customers/${id}`);
  }

  async create(data) {
    return this.#_api.post("/Accounting/Customers", data);
  }

  async update(id, data) {
    return this.#_api.put(`/Accounting/Customers/${id}`, data);
  }

  async schema() {
    return [
      { key: "id", label: "Código", type: "number", visible: true },
      { key: "name", label: "Nome / razão social", type: "string", visible: true },
      { key: "document", label: "CPF / CNPJ", type: "string", visible: true },
      { key: "disabled", label: "Inativo", type: "boolean", visible: true },
    ];
  }
}

export default Customers;
